(()=>{
'use strict';
if(window.AWP27ClientInsights?.version)return;
const VERSION='2.7.4';
const ORDER=['propulsion','power_j','velocity','barrel_mm','connector','battery','gas','operating_pressure','magazine_standard','magazine_capacity','thread','mounting','optic_mount','hopup','electronics','gearbox','motor','hpa_engine','internal_standard','action_system','weight_g','length_mm','height_mm','width_mm','fire_modes','material','calibre','empty_mag_detection','quick_change_spring'];
const LABELS={propulsion:'Propulsion',power_j:'Puissance',velocity:'Vélocité',barrel_mm:'Canon interne',connector:'Connecteur',battery:'Batterie',gas:'Gaz / alimentation',operating_pressure:'Pression de service',magazine_standard:'Standard chargeur',magazine_capacity:'Capacité chargeur',thread:'Filetage',mounting:'Interfaces / rails',optic_mount:'Interface optique',hopup:'Hop-Up',electronics:'Électronique / ETU',gearbox:'Gearbox',motor:'Moteur',hpa_engine:'Moteur HPA',internal_standard:'Standard interne',action_system:'Mécanisme / réarmement',weight_g:'Poids',length_mm:'Longueur',height_mm:'Hauteur',width_mm:'Largeur',fire_modes:'Modes de tir',material:'Construction',calibre:'Calibre',empty_mag_detection:'Détection chargeur vide',quick_change_spring:'Changement rapide du ressort'};
const parse=v=>{try{return JSON.parse(v||'[]')}catch(_){return[]}};
const node=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!==undefined)e.textContent=text;return e};
const best=(profile,key)=>window.AWTechnicalIntelligenceP27?.strongestFact?.(profile,key)||(profile?.byKey?.get(key)||[]).slice().sort((a,b)=>(Number(b.decisionGrade)-Number(a.decisionGrade))||(Number(b.score||0)-Number(a.score||0)))[0]||null;
const label=k=>LABELS[k]||String(k||'').replaceAll('_',' ');
function factCard(engine,profile,key){
  const value=engine.display(profile,key);if(!value)return null;
  const f=best(profile,key),card=node('div','aw-p27-insights__fact');
  const head=node('div','aw-p27-insights__fact-head');
  head.append(node('strong','',label(key)));
  const badge=node('span','aw-p27-insights__grade '+(f?.decisionGrade?'is-verified':'is-documented'),f?.decisionGrade?'Vérifié':'Documenté');
  head.append(badge);card.append(head,node('p','aw-p27-insights__value',value));
  const meta=[];
  if(f?.score)meta.push('score '+f.score+'/100');
  if(f?.date)meta.push('vérifié le '+f.date);
  if(meta.length)card.append(node('small','aw-p27-insights__meta',meta.join(' · ')));
  if(f?.proof||f?.sourceUrl||f?.condition){
    const details=node('details','aw-p27-insights__proof'),summary=node('summary','','Voir la preuve');
    details.append(summary);
    if(f.condition)details.append(node('p','',f.condition));
    if(f.proof)details.append(node('p','',f.proof));
    if(/^https?:\/\//i.test(f.sourceUrl||'')){
      const a=node('a','','Ouvrir la source');a.href=f.sourceUrl;a.target='_blank';a.rel='noopener noreferrer';details.append(a);
    }
    card.append(details);
  }
  return card;
}
function answerTool(engine,profile){
  const d=node('details','aw-p27-insights__tool'),s=node('summary','','Question technique');
  d.append(s);
  const p=node('p','aw-p27-insights__tool-copy','La réponse utilise uniquement les faits présents sur ce modèle. Une donnée absente reste inconnue.');
  const form=node('form','aw-p27-insights__form'),input=node('input',''),button=node('button','','Consulter les faits'),result=node('div','aw-p27-insights__result');
  input.type='search';input.placeholder='Ex. quel connecteur ? quel filetage ?';input.setAttribute('aria-label','Question technique');button.type='submit';result.setAttribute('aria-live','polite');
  form.append(input,button);d.append(p,form,result);
  form.addEventListener('submit',e=>{
    e.preventDefault();result.textContent='';
    const ctx=engine.answerContext(profile,input.value);
    if(ctx.facts.length){
      const list=node('ul','');
      ctx.facts.forEach(f=>{const li=node('li','');li.append(node('strong','',f.label+' : '),document.createTextNode(f.value+' · '+(f.verified?'Vérifié':'Documenté')));list.append(li)});
      result.append(list);
    }
    if(ctx.unknown.length)result.append(node('p','aw-p27-insights__unknown','Non documenté : '+ctx.unknown.map(label).join(', ')+'.'));
    if(!ctx.facts.length&&!ctx.unknown.length)result.append(node('p','','Aucun fait correspondant n’est actuellement documenté.'));
    try{window.AWAnalytics?.track?.('p27_customer_question',{version:VERSION,known:ctx.facts.length,unknown:ctx.unknown.length})}catch(_){}
  });
  return d;
}
function diagnosticTool(engine,profile){
  const d=node('details','aw-p27-insights__tool'),s=node('summary','','Aide au diagnostic');
  d.append(s);
  const p=node('p','aw-p27-insights__tool-copy','Décrivez un symptôme : P2.7 prépare une checklist de contrôle sans inventer la cause.');
  const form=node('form','aw-p27-insights__form'),input=node('input',''),button=node('button','','Préparer le contrôle'),result=node('div','aw-p27-insights__result');
  input.type='search';input.placeholder='Ex. manque de précision, coupure batterie…';input.setAttribute('aria-label','Symptôme à contrôler');button.type='submit';result.setAttribute('aria-live','polite');
  form.append(input,button);d.append(p,form,result);
  form.addEventListener('submit',e=>{
    e.preventDefault();result.textContent='';
    const ctx=engine.diagnosticContext(profile,input.value),list=node('ul','');
    ctx.checks.slice(0,6).forEach(c=>{const suffix=c.known?' — '+c.value+(c.verified?' · Vérifié':' · Documenté'):' — donnée inconnue';list.append(node('li','',c.reason+suffix))});
    result.append(list,node('small','aw-p27-insights__caution','Cette checklist aide au contrôle ; elle ne prouve pas la cause d’une panne.'));
    try{window.AWAnalytics?.track?.('p27_diagnostic_context',{version:VERSION,checks:ctx.checks.length,unknown:ctx.unknown.length})}catch(_){}
  });
  return d;
}
function recommendationTool(engine,profile){
  const d=node('details','aw-p27-insights__tool'),s=node('summary','','Contexte de recommandation');
  d.append(s);
  const ctx=engine.recommendationContext(profile),constraints=ctx.constraints||engine.recommendationConstraints?.(profile)||{hard:[],informational:[]};
  d.append(node('p','aw-p27-insights__tool-copy','Les faits Vérifié ≥90 peuvent restreindre les candidats. Ils ne remplacent jamais la Compatibility exacte.'));
  const result=node('div','aw-p27-insights__result');
  if(constraints.hard?.length){
    const list=node('ul','');
    constraints.hard.slice(0,8).forEach(c=>list.append(node('li','',c.label+' : '+c.value+' · Vérifié')));
    result.append(list);
  }
  if(ctx.signals?.length){
    const list=node('ul','');
    ctx.signals.slice(0,5).forEach(x=>list.append(node('li','',x.reason)));
    result.append(list);
  }
  if(!constraints.hard?.length&&!ctx.signals?.length)result.append(node('p','','Aucune contrainte technique supplémentaire n’est nécessaire à ce stade.'));
  if(constraints.informational?.length)result.append(node('small','aw-p27-insights__caution',constraints.informational.length+' fait(s) Documenté ≥80 restent informatifs et ne filtrent pas seuls une recommandation.'));
  d.append(result);
  return d;
}
function atelierTool(engine,profile){
  const d=node('details','aw-p27-insights__tool'),s=node('summary','','Brief Atelier');
  d.append(s);
  const brief=engine.atelierBrief(profile),result=node('div','aw-p27-insights__result');
  const list=node('ul','');
  brief.checklist.slice(0,8).forEach(c=>list.append(node('li','',c.label+' : '+c.value+' · '+(c.verified?'Vérifié':'Documenté'))));
  if(list.children.length)result.append(list);
  if(brief.missingCore.length)result.append(node('p','aw-p27-insights__unknown','À relever / confirmer : '+brief.missingCore.map(label).join(', ')+'.'));
  if(brief.conflicts.length)result.append(node('p','aw-p27-insights__alert','Contradictions à contrôler avant intervention : '+brief.conflicts.map(x=>x.label).join(', ')+'.'));
  result.append(node('small','aw-p27-insights__caution',brief.caution));
  d.append(result);
  return d;
}
function render(host){
  if(host.dataset.awP27Ready==='true')return true;
  const engine=window.AWTechnicalIntelligenceP27;if(!engine)return false;
  const scope=host.closest('.page-width')||host.parentElement||document;
  const data=scope.querySelector('[data-aw-p27-product-profile]');if(!data)return false;
  const profile=engine.buildProfile(parse(data.textContent));if(!profile.facts.length)return false;
  host.textContent='';
  const wrap=node('div','aw-p27-insights');
  const header=node('div','aw-p27-insights__header'),title=node('div','');
  title.append(node('span','aw-p27-insights__eyebrow','DONNÉES TECHNIQUES AW'),node('h3','','Profil technique documenté'));
  const badges=node('div','aw-p27-insights__badges');
  badges.append(node('span','is-verified',profile.verified.length+' Vérifié ≥90'));
  if(profile.documented.length)badges.append(node('span','is-documented',profile.documented.length+' Documenté ≥80'));
  header.append(title,badges);wrap.append(header);
  wrap.append(node('p','aw-p27-insights__intro','Les faits vérifiés peuvent éclairer une décision technique. Les faits documentés restent informatifs. Aucune compatibilité n’est créée à partir de ces seules caractéristiques.'));
  const grid=node('div','aw-p27-insights__grid'),shownKeys=new Set;
  let shown=0;
  for(const key of ORDER){const card=factCard(engine,profile,key);if(card){grid.append(card);shownKeys.add(key);shown++;if(shown>=12)break}}
  if(shown)wrap.append(grid);
  const extras=[...profile.byKey.keys()].filter(key=>!shownKeys.has(key)&&engine.display(profile,key)).slice(0,24);
  if(extras.length){
    const more=node('details','aw-p27-insights__more'),summary=node('summary','','Voir '+extras.length+' autre'+(extras.length>1?'s':'')+' fait'+(extras.length>1?'s':'')+' technique'+(extras.length>1?'s':''));
    const extraGrid=node('div','aw-p27-insights__grid aw-p27-insights__grid--more');
    extras.forEach(key=>{const card=factCard(engine,profile,key);if(card)extraGrid.append(card)});
    more.append(summary,extraGrid);wrap.append(more);
  }
  const diag=engine.diagnostics(profile);
  if(diag.conflicts.length){
    wrap.append(node('div','aw-p27-insights__alert','Contrôle requis : '+diag.conflicts.map(x=>x.label).join(', ')+' présente des faits Vérifié ≥90 divergents. Aucun verdict automatique n’est appliqué.'));
  }else if(diag.missingCore.length){
    wrap.append(node('div','aw-p27-insights__unknown','Données encore inconnues : '+diag.missingCore.map(label).join(', ')+'.'));
  }
  const tools=node('div','aw-p27-insights__tools');tools.append(answerTool(engine,profile),diagnosticTool(engine,profile),recommendationTool(engine,profile),atelierTool(engine,profile));wrap.append(tools);
  const atelier=scope.querySelector('a[data-aw-p1-track="pdp_to_garage"],a[href*="mon-atelier-airsoft"]');
  if(atelier){
    const cta=node('div','aw-p27-insights__cta'),a=node('a','button button--secondary','Ouvrir Mon Atelier');
    a.href=atelier.href;a.dataset.awP1Track='p27_to_atelier';cta.append(node('span','','Besoin d’un contrôle physique ou d’une intervention ?'),a);wrap.append(cta);
  }
  host.append(wrap);host.hidden=false;host.dataset.awP27Ready='true';
  try{window.AWAnalytics?.track?.('p27_client_insights_ready',{version:VERSION,verified:profile.verified.length,documented:profile.documented.length,conflicts:diag.conflicts.length})}catch(_){}
  return true;
}
function run(){let ok=false;document.querySelectorAll('[data-aw-p27-client-insights]').forEach(h=>{ok=render(h)||ok});return ok}
const boot=()=>{run();if(!window.AWTechnicalIntelligenceP27)window.addEventListener('aw:p27:technical-intelligence-ready',run,{once:true})};
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
document.addEventListener('shopify:section:load',run);
window.AWP27ClientInsights={version:VERSION,run,policy:'read-only client exposure; verified>=90 decision-grade; documented>=80 informational; missing stays unknown; no compatibility inference'};
})();